<template>
    <div>

        <footer class="footer-main" role="contentinfo">
            <div class="container">
                <div class="row mb-4">
                    <div class="col-md-10 ml-auto mr-auto small">
                      <p>
                        *One (1) Grand Prize: a Tempur-Pedic bed of the winner's choice, with a maximum retail value of $5,000. Prize will be awarded as a one-time use promo code valid on tempurpedic.com for one (1) mattress only, one (1) bed base only, or a one (1) mattress one (1) bed base combination.
                      </p>
                        <p>No purchase necessary to enter or win. Open 6/25/2020 – 7/9/2020 to original recipients of the email invite who are residents of the U.S., 18 or older. <a href @click.prevent="$root.$emit('showRulesModal')"><strong>See official rules</strong></a>. </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <p class="small">
                            &copy; Sleep Outfitters USA {{ new Date().getFullYear() }}. All Rights Reserved.
                            &nbsp; <a href="https://www.sleepoutfitters.com/privacy-policy" target="_blank">Privacy Policy</a>
                        </p>
                    </div>
                </div>
            </div>
        </footer>

    </div>
</template>

<script>
export default {
    name: 'footer-main',
    data () {
        return {
        }
    },
    methods: {
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';

    .footer-main {
        position: relative;
        height: auto;
        text-align: center;
        transition: $transition;
        background-color: $dark-grey;
        color: $white;
        padding: 22px 0 10px;
        line-height: 1.8;

        a {
            text-decoration: none;
            color: $white;

            &::hover {
                color: lighten($blue, 35%);
            }
        }

        svg {
            margin-right: 5px;
        }
    }
</style>
